import type { IconGlyph } from '../icon';

import { iconNotificationThick } from './notification-thick';

/**
 * Tractie `notification` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/notification.jsx`.
 * Verbatim copy of the SVG `d` attribute.
 *
 * The source viewBox is 24×25. The lowest point of the shape (the bottom of
 * the clapper arc) sits at about y 21.4, so the glyph renders in the default
 * 24×24 box without clipping.
 */
export const iconNotification: IconGlyph = {
  name: 'notification',
  path: 'M20 17.81c-.02-.23-.05-.45-.09-.67-.18-.82-.68-1.55-1.44-2.23-.07-.07-.15-.2-.23-.41-.07-.2-.12-.43-.16-.67-.07-.42-.07-.79-.07-.84v-2.77c0-1.33-.25-2.62-.86-3.7a5 5 0 0 0-2.7-2.26c-.28-1.04-1.31-1.77-2.43-1.77s-2.15.73-2.43 1.77c-1.24.45-2.13 1.25-2.7 2.26-.61 1.07-.86 2.36-.86 3.7v3c0 .16-.03.37-.06.6-.04.23-.09.46-.16.67-.07.2-.15.33-.23.4-.77.68-1.27 1.41-1.44 2.23-.05.22-.08.44-.09.67s0 .04 0 .07c0 .97.84 1.62 1.74 1.62H9.6a2.5 2.5 0 0 0 4.9 0h3.81c.9 0 1.74-.65 1.74-1.62v-.07Zm-8 2.69c-.65 0-1.21-.42-1.41-1h2.83c-.21.58-.76 1-1.41 1Zm6.26-2H5.74c-.47 0-.74-.31-.74-.62.01-.18.04-.35.07-.52.12-.55.47-1.11 1.14-1.7.24-.22.39-.52.49-.8s.17-.58.21-.85c.08-.54.08-.99.08-1.01v-2.75c0-1.22.23-2.32.73-3.2.5-.87 1.27-1.54 2.42-1.9l.31-.1.04-.32c.07-.64.71-1.21 1.5-1.21s1.43.57 1.5 1.21l.04.32.31.1c1.15.36 1.92 1.03 2.42 1.9.5.88.73 1.98.73 3.2V13c0 .08 0 .51.08 1.01.04.27.11.57.21.85s.25.57.49.8 0 .01 0 .01c.67.59 1.02 1.15 1.14 1.7.04.17.06.35.07.52 0 .32-.28.62-.74.62Z',
  selected: iconNotificationThick,
};
